import { TreeNode } from '../TreeNode';
import { Container } from './styled';
export function Tree(props) {
    const { items, isLastItem } = props;
    return (<Container $isLastItem={isLastItem}>
      {items.map((item, index) => (<TreeNode key={item.id} item={item} isLastItem={index === items.length - 1}/>))}
    </Container>);
}
